<template>
  <v-card height="100%" :loading="storageSection.loading" flat color="bg1" class="pt-2"  >
  
    <v-sheet outlined class="pa-4 rounded-lg  ma-5 ml-8  ">
         <v-list-item two-line :class="$vuetify.theme.isDark ? 'bg2' : 'white'">
      <v-list-item-content>
        <v-list-item-title class="title">Custom Domain Settings</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
 <v-form v-model="valid">
      <v-sheet
      
        color="transparent"
        tile
        class="overflow-hidden pa-4 d-flex flex-column"
        style="gap: 1.5rem">
         <v-label   class="black--text mb-2 d-block">Domain Name</v-label>
        <v-text-field
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="company.customDomainName"
              placeholder="Custom Domain"></v-text-field>

        <!-- Save Button -->
        <div class="d-flex justify-end">
          <v-btn
            large
            text
            color="primary"
            :disabled="domainSection.loading"
            :loading="domainSection.loading"
            @click="saveDomainName">
            Save
          </v-btn>
        </div>
      </v-sheet>
    </v-form>
    </v-sheet>
    <v-sheet outlined class="pa-4 rounded-lg  ma-5 ml-8">
         <v-list-item two-line :class="$vuetify.theme.isDark ? 'bg2' : 'white'">
      <v-list-item-content>
        <v-list-item-title class="title">Storage Settings</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
     <v-divider></v-divider>
 <v-form v-model="valid">
      <v-sheet
      
        color="transparent"
        tile
        class="overflow-hidden pa-4 d-flex flex-column"
        style="gap: 1.5rem">
        
      <v-alert text v-if="!storage.hasCustomStorage" color="blue" >
          <v-icon small color="blue">mdi-information</v-icon>  Your data and your company’s data are securely stored in our reliable AVA Cloud Storage. However, you also have the option to use a custom storage solution — we support both Azure Blob Storage and any AWS-compatible storage provider.
            </v-alert>
              <v-checkbox label=" Enable Custom Storage" v-model="storage.hasCustomStorage" ></v-checkbox>
              <div v-if="storage.hasCustomStorage" class="storage-items-wrapper" >
                <v-label class="black--text mb-2 d-block">Provider</v-label>
              <v-select  v-model="storage.providerName" :items="cloudProviders" attach>
                 <template v-slot:selection="{item}">
               <div class="pa-2 d-flex justify-center align-center" style="height: 45px;">
                 <img width="32px" height="32px" :src="item.imageUrl"  class="mr-1"> <span>{{ item.text }}</span>
               </div>
                </template>
                <template v-slot:item="{item}">
                <img width="32px" :src="item.imageUrl" class="mr-1"  > <span>{{ item.text }}</span>
                </template>
              </v-select>
            <v-label v-if="storage.providerName=='azure'" class="black--text mb-2 d-block">Connection String</v-label>
            <v-text-field
            v-if="storage.providerName=='azure'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.connectionString"
              :rules="[formRules.required]"
              placeholder="Connection string"></v-text-field>
              <v-label v-if="storage.providerName=='aws'" class="black--text mb-2 d-block">Server Url</v-label>
            <v-text-field
            v-if="storage.providerName=='aws'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.serverUrl"
              placeholder="Server Url for ex: http://127.0.0.1:9000/"></v-text-field>

              <v-label v-if="storage.providerName=='aws'" class="black--text mb-2 d-block">Region</v-label>
            <v-text-field
            v-if="storage.providerName=='aws'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.awsRegion"
              placeholder="Region for Ex: us-east-1"></v-text-field>

              <v-label v-if="storage.providerName=='aws'" class="black--text mb-2 d-block">Key</v-label>
            <v-text-field
            v-if="storage.providerName=='aws'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.key"
              placeholder="Account Key"></v-text-field>
            <v-label v-if="storage.providerName=='aws'" class="black--text mb-2 d-block">Secret</v-label>
            <v-text-field
            v-if="storage.providerName=='aws'"
              dense
              outlined
              :background-color="$vuetify.theme.isDark ? 'bg2' : 'white'"
              v-model="storage.secret"
              :rules="[formRules.required]"
              placeholder="Account Secret"></v-text-field>
              <v-row>
                <v-col class="d-flex justify-space-between">
                  <v-btn :loading="storageSection.loading" @click="validateConnection" color="primary">
                    <v-icon>mdi-check-circle-outline</v-icon> Validate Connection
                  </v-btn>
                  <v-alert   dense text color="success" v-if="storageSection.success" > Storage Connected successfully!</v-alert>
                  <v-alert dense text color="error" v-if="storageSection.errorMessage" >{{ storageSection.errorMessage }}</v-alert>
                  
                </v-col>
              </v-row>
              </div>

        <!-- Save Button -->
        <div class="d-flex justify-end">
          <v-btn
            :disabled="!valid || !hasChanges"
            large
            text
            color="primary"
            :loading="storageSection.loading"
            @click="saveStorageInfo">
            Save
          </v-btn>
        </div>
      </v-sheet>
    </v-form>
    </v-sheet>
   
  </v-card>
</template>

<script>
  import permissions from '@Share/config/permissions';
  import { $has } from '@/utils';
  import formRules from '@Share/config/form-rules';
import companyService from '@/features/Company/service/company-management.service';
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';
  export default {
    name: 'StorageSettings',
    props:['companyId'],
    data() {
      return {
        valid:false,
        storage:{},
        company:{},
        formRules,
              permissions,
          domainSection: {
              loading: false,
          },
        storageSection:{
            loading:false,
             success:false,
             errorMessage:null
        },
        cloudProviders:[
          {
            text:'Azure',value:'azure',imageUrl:'/img/icons8-azure-storage-blob-32.svg'
            
          },{
            text:'AWS S3 Compatible storage',value:'aws',imageUrl:'/img/aws-s3.png'
          }
        ],
  
       
      };
    },
    computed: {
    //   ...mapGetters('ACCOUNT', {
    //     user: 'GET_USER',
    //   }),
      userPreferences() {
        return this.user?.userPreferences || {};
      },
      hasChanges() {
        return JSON.stringify(this.storage) !== JSON.stringify(this.originalStorage);
      },
    
    },
    watch: {
      
      },
      
    methods: {
      $has,
      saveDomainName(){
        this.domainSection.loading=true;
            companyService.update(this.company).then(()=>{
                     this.$dialog.notify.success('Custom domain updated successfully.', {
                    position: 'top-right',
                    timeout: 2000,
                  });
            }).catch((error)=>{
                debugError(error);
                          this.$dialog.notify.error('Failed to update domain name');
            }).finally(()=>{
                this.domainSection.loading=false;
            })
      },
      resetstorageSection() {
        this.storageSection.loading = false;
        this.storageSection.success = false;
        this.storageSection.errorMessage = null;
      },
      validateConnection(){
          this.storageSection.loading=true;
             companyService.validateStorage(this.companyId,this.storage).then((res)=>{
            if(res.data.succeeded){
              this.storageSection.success=true;
            }else{
              this.storageSection.success=false;
               this.storageSection.errorMessage=res.data.errorMessage||'Unknown error establishing connection with the storage!';
            }
        }).catch(error=>{
          debugLog("error",error);
        }).finally(()=>{
           this.storageSection.loading=false;
        })
         
      },
      saveStorageInfo(){
        companyService.validateStorage(this.companyId,this.storage).then((res)=>{
            if(res.data.succeeded){
               companyService.updateStorage(this.companyId,this.storage).then(()=>{
                
                   this.$dialog.notify.success('Storage settings updated successfully.', {
                    position: 'top-right',
                    timeout: 2000,
                  });
       }).catch(error=>{
          debugError(error);
                          this.$dialog.notify.error('Failed to update storage information');
       }).finally(()=>{

       });
            }
        })
       
      }
    },
    mounted() {
        this.storageSection.loading=true;
       companyService.getStorage(this.companyId).then(res=>{
        this.storage=res.data;
        this.originalStorage=structuredClone(this.storage);
       }).catch(error=>{
          debugError(error);
        this.$dialog.notify.error('Failed to get company information');
       }).finally(()=>{
    this.storageSection.loading=false;
       });

        this.domainSection.loading=true;
         companyService.getById(this.companyId).then(res=>{
        this.company=res.data;
        this.originalCompany=structuredClone(this.company);
       }).catch(error=>{
          debugError(error);
          this.$dialog.notify.error('Failed to get storage information');
       }).finally(()=>{
    this.domainSection.loading=false;
       });
    }
  };
</script>

<style scoped>
  .v-radio {
    margin-bottom: 8px;
  }
</style> 